// @ts-nocheck
import { Plugin } from '/home/jenkins/workspace/ansible-ui/route-forecast-ui/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','qiankun','request',],
});

export { plugin };
